<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" :class="btnClass" :disabled="disabled" x-small @click="actionClick" v-if="size==='x-small'"><v-icon left x-small v-if="icon!==''">{{ icon }}</v-icon>{{ text }}</v-btn>
            <v-btn v-on="on" :class="btnClass" :disabled="disabled" small   @click="actionClick" v-if="size==='small'"  ><v-icon left small   v-if="icon!==''">{{ icon }}</v-icon>{{ text }}</v-btn>
            <v-btn v-on="on" :class="btnClass" :disabled="disabled" default @click="actionClick" v-if="size==='default'"><v-icon left default v-if="icon!==''">{{ icon }}</v-icon>{{ text }}</v-btn>
            <v-btn v-on="on" :class="btnClass" :disabled="disabled" large   @click="actionClick" v-if="size==='large'"  ><v-icon left large   v-if="icon!==''">{{ icon }}</v-icon>{{ text }}</v-btn>
            <v-btn v-on="on" :class="btnClass" :disabled="disabled" x-large @click="actionClick" v-if="size==='x-large'"><v-icon left x-large v-if="icon!==''">{{ icon }}</v-icon>{{ text }}</v-btn>
        </template>
        <span v-html="convertTextToHtml(tooltip)"></span>
    </v-tooltip>
</template>

<script>
    export default { 
        props: {
            data: {
                required: true,               
            },
            text: {
                type: String,
                required: false,  
                default: ""            
            },  
            icon: {
                type: String,
                required: false,  
                default: ""            
            },  
            tooltip: {
                type: String,
                required: false,
                default: "Click me",
            },
            size: {
                type: String,
                required: false,
                default: "default",
            },
            color: {
                type: String,
                required: false,
                default: "primary",
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false,                
            }
        },
        data() {
            return {
            }
        },
        computed: {
            btnClass: function () {
                return "action mx-1 " + this.color;
            }
        },  
        methods: {
            actionClick() {
                this.$emit("actionClick", this.data);
            },
            convertTextToHtml(text) {
                return text.replace(/\n/gi, '<br>'); // yes indeed, regular expression!!
            },
        },
    }

</script>

<style scoped>
    .action {
        cursor: pointer;
    }
</style>